export default function hasProperty(object, key) {
    return Object.hasOwn(object, key);
}
